import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import ArrowIcon from '../icons/Arrow';

import styles from '../../../styles/buttons/arrow.scss';

const propTypes = {
    color: PropTypes.string,
    isActive: PropTypes.bool,
    isLeft: PropTypes.bool,
    onClick: PropTypes.func,
    className: PropTypes.string,
};

const defaultProps = {
    color: null,
    isActive: false,
    isLeft: false,
    onClick: null,
    className: null,
};

const Arrow = ({ color, isActive, isLeft, onClick, className }) => (
    <div className={classNames([styles.container, { [className]: className !== null }])}>
        <button
            className={classNames([styles.arrow, { [styles.isActive]: isActive }])}
            type="button"
            onClick={onClick}
        >
            <ArrowIcon color={color} isLeft={isLeft} />
        </button>
    </div>
);

Arrow.propTypes = propTypes;
Arrow.defaultProps = defaultProps;

export default Arrow;
